var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotFound = function SvgNotFound(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 181,
    height: 96,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#5D6470",
    strokeWidth: 1.6,
    d: "M135.52 77.88v-9.94h-26.77c-.57 0-.99-.35-.99-.99v-2.56c0-.43.07-.85.43-1.21l29.76-40.12c.28-.43.64-.64 1.21-.64h5.75c.64 0 .99.36.99.99v34.8h7.31c.64 0 .99.35.99.99v7.74c0 .64-.36.99-.99.99h-7.31v9.94c0 .64-.36.99-.99.99h-8.38c-.57 0-.99-.35-.99-.99zm0-19.67V41.74l-11.44 16.47z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5D6470",
    strokeMiterlimit: 10,
    strokeWidth: 1.6,
    d: "M115.88 8a3.6 3.6 0 1 0 0-7.2 3.6 3.6 0 0 0 0 7.2ZM171.24 44.85l-1.01-6.45a.736.736 0 0 0-1.19-.46l-5.08 4.1a.736.736 0 0 0 .2 1.26l6.09 2.35c.53.2 1.08-.24.99-.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5D6470",
    strokeWidth: 1.6,
    d: "M45.52 77.88v-9.94H18.75c-.57 0-.99-.35-.99-.99v-2.56c0-.43.07-.85.43-1.21l29.76-40.12c.28-.43.64-.64 1.21-.64h5.75c.64 0 .99.36.99.99v34.8h7.31c.64 0 .99.35.99.99v7.74c0 .64-.36.99-.99.99H55.9v9.94c0 .64-.36.99-.99.99h-8.38c-.57 0-.99-.35-.99-.99zm0-19.67V41.74L34.08 58.21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F3F4F8",
    d: "M108.84 69.83a24.24 24.24 0 0 1-12.1 3.24c-4.24 0-8.43-1.12-12.1-3.24-7.46-4.31-12.1-12.34-12.1-20.96s4.64-16.65 12.1-20.96c3.67-2.12 7.86-3.24 12.1-3.24s8.43 1.12 12.1 3.24c7.46 4.31 12.1 12.34 12.1 20.96s-4.64 16.65-12.1 20.96"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D6470",
    d: "M88.86 40.99c.31-.32.83-.32 1.15 0l6.73 6.73 6.73-6.73c.31-.32.83-.32 1.15 0 .31.31.31.83 0 1.15l-6.73 6.73 6.73 6.73c.31.32.31.83 0 1.15-.31.31-.83.31-1.15 0l-6.73-6.73-6.73 6.73c-.31.31-.83.31-1.15 0a.827.827 0 0 1 0-1.15l6.73-6.73-6.74-6.74a.827.827 0 0 1 0-1.15h.01z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#5D6470",
    d: "m134.3 85.3-18.62-18.62-.14-.14.13-.14c4.43-4.78 6.87-11 6.87-17.53 0-14.23-11.57-25.8-25.8-25.8s-25.8 11.57-25.8 25.8 11.57 25.8 25.8 25.8c6.52 0 12.75-2.44 17.53-6.87l.14-.13.14.14 18.62 18.62a.81.81 0 0 0 1.13 0c.31-.31.31-.82 0-1.13m-25.46-15.47a24.24 24.24 0 0 1-12.1 3.24c-4.24 0-8.43-1.12-12.1-3.24-7.46-4.31-12.1-12.34-12.1-20.96s4.64-16.65 12.1-20.96c3.67-2.12 7.86-3.24 12.1-3.24s8.43 1.12 12.1 3.24c7.46 4.31 12.1 12.34 12.1 20.96s-4.64 16.65-12.1 20.96"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5D6470",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6,
    d: "m13 30.26 7.51-2.76M15.37 25.12l2.77 7.51"
  })));
};
export default SvgNotFound;